"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthError = void 0;
class AuthError extends Error {
    constructor(message, previous) {
        super(message);
        this.previous = previous;
        this.errors = [];
    }
}
exports.AuthError = AuthError;
//# sourceMappingURL=AuthError.js.map